import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect, useState } from 'react';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import { DisplayListPagination } from '../../../components/TapUi';
import { toast } from 'react-toastify';
import swal from "sweetalert";


const ManufacturerListing = ({ history, location }) => {
    const [minimizeTable, setMinimizeTable] = useState(false);
    const [manufacturerDetail, setManufacturerDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [manufacturerData, setManufacturerData] = useState([]);
    const [manufacturerDetailLoading, setManufacturerDetailLoading] = useState(false);

    const [listingMeta, setListingMeta] = useState(null);
    const access_token = useSelector(state => state.auth.access_token);
    const viewManufacturerData = (id) => {
        if (minimizeTable && manufacturerDetail?.id === id) {
            return;
        }
        setMinimizeTable(true);
        setManufacturerDetailLoading(true)
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/iot_manufacturer_detail/' + id, access_token, {}, {}, (resp) => {
            const respData = resp?.data
            setManufacturerDetail(respData);
        }).then(() => setManufacturerDetailLoading(false))
    }

    const closeView = () => {
        setMinimizeTable(false);
        setManufacturerDetail(null);
    }
    const editManufacturerInit = (item) => {
        history.push({ pathname: `/manufacturer_add`, state: { editManufacturerData: item } });
    };
    const getManufacturerListing = (page = 1) => {
        setLoading(true)
        const params = { page: page, per_page: 50, };
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/iot_manufacturer_list', access_token, {}, params, (resp) => {
            const respData = resp.data
            setManufacturerData(respData.data);
            setListingMeta({
                'from': respData.from,
                'to': respData.to,
                'total': respData.total,
                'last_page': respData.last_page,
                'per_page': respData.per_page,
                'current_page': respData.current_page
            });
        }).then(() => setLoading(false));

    }
    useEffect(() => {
        getManufacturerListing(1)
        if (location?.state?.id) {
            viewManufacturerData(location.state.id);
        }
    }, [])
    const manufacturerListingJsx = () => {
        return (
            <>
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        {minimizeTable ? (
                            <tr>
                                <th scope="col" style={{ width: "8%" }}>Manufacturer Listing</th>
                            </tr>
                        ) : (
                            <tr>
                                <th className='text-center' style={{ width: "10%" }}>S.No.</th>
                                <th className='text-center ms-3' style={{ width: "40%" }}>Manufacturer Name</th>
                                <th className='text-center ms-3' style={{ width: "50%" }}>Notes</th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {loading
                            ?
                            <tr><td colSpan={3}><Loader /></td></tr>
                            :
                            manufacturerData.length > 0
                                ?
                                manufacturerData.map((i, k) => {
                                    return (<>
                                        <tr key={k}>
                                            {minimizeTable ? (
                                                <td style={{ width: "25%" }} className='text-start'>
                                                    <a
                                                        href="#"
                                                        className="text-capitalize link-primary"
                                                        onClick={() => viewManufacturerData(i.id)}
                                                    >
                                                        {i.name}
                                                    </a>
                                                </td>
                                            ) : (
                                                <>
                                                    <td className='text-center'>{k + 1}</td>
                                                    <td className='text-center'>
                                                        <a
                                                            href="#"
                                                            className="text-capitalize link-primary "
                                                            onClick={() => viewManufacturerData(i.id)}
                                                        >
                                                            {i.name}
                                                        </a>
                                                    </td>
                                                    <td className='text-center'>{i.notes}</td>
                                                </>
                                            )}
                                        </tr>
                                    </>)
                                })
                                :
                                <tr><td colSpan="3" className="text-center">No Records</td></tr>
                        }
                    </tbody>
                </table>
                <DisplayListPagination meta={listingMeta} onPageChange={(e) => getManufacturerListing(e.selected + 1)} />

            </>
        );
    };
    const deleteManufacturerInit = (id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {

                HttpAPICall.withAthorization('DELETE', BACKOFFICE_BASE_URL + '/iot_manufacturer_delete/' + id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    setMinimizeTable(false)
                    getManufacturerListing(1);
                }).then(() => { });
            }
        });
    }
    const manufacturerJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className={minimizeTable ? "col-3" : "col-12"}>
                        <h3>Manufacturer Listing</h3>
                        {(!minimizeTable) ? (
                            <div className="text-end mt15">
                                <>
                                    <Link to="/manufacturer_add">
                                        <button type="button" className="btn btn-primary">Add</button>
                                    </Link>
                                </>
                            </div>
                        ) : null}
                    </div>
                    {minimizeTable ? (
                        <div className="col-9 tap_border_left">
                            <div className="text-end mt15">
                                <span className="dropdown">
                                    <button
                                        type="button"
                                        id='actionMenuButton'
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className="btn btn-secondary"
                                    >
                                        <TapIcon.imageIcon icon={TapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li>
                                            <button className='dropdown-item' onClick={() => editManufacturerInit(manufacturerDetail)}>Edit</button>
                                        </li>
                                        <li><button className='dropdown-item' onClick={() => deleteManufacturerInit(manufacturerDetail.id)}>Delete</button></li>
                                    </ul>
                                </span>
                                <button
                                    type="button"
                                    className="btn btn-secondary ms-2"
                                    onClick={closeView}
                                >
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', minimizeTable ? 'col-3' : 'col-12'].join(' ')}>
                            {manufacturerListingJsx()}
                        </div>
                        {minimizeTable ? (
                            <div className="col-9 pr4 pl4">
                                <div className="bg-white p-2" style={{ height: "100%" }}>
                                    {manufacturerDetails()}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </>
        );
    };

    const manufacturerDetails = () => {

        return (
            <div className="tab_content_header">
                <div className="tab_content_wrapper">
                    <span className="content_heading">Manufacturer Details</span>
                </div>
                {manufacturerDetailLoading ? <Loader /> :
                    manufacturerDetail && <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                        <tbody>
                            <tr>
                                <td style={{ width: "26%" }}>ManuFacturer Name</td>
                                <th>{manufacturerDetail.name}</th>
                            </tr>
                            <tr>
                                <td style={{ width: "26%" }}>Notes</td>
                                <th>{manufacturerDetail.notes}</th>
                            </tr>
                        </tbody>
                    </table>}


            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Manufacturer Listing</title></Helmet>
            {manufacturerJsx()}
        </ApplicationLayout>
    );
};

export default ManufacturerListing;
